<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-10 16:54:56
-->
<template>
  <div>
    <div class="maintitle">部门考核</div>
    <el-divider></el-divider>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="department" width='100' label="部门"></el-table-column>
      <el-table-column prop="month" label="考核月份"></el-table-column>
      <el-table-column label="自评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.selfexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.leaderexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="ass(scope)" size='mini'>查看</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :title='crntDep' :visible.sync="assDiv" :show-close="false" width='100%' :close-on-click-modal="false">
      <el-table :data="alist" row-key="id" border width="100%">
        <el-table-column v-for="(item,index) in trList" :key="index" :label="item.label" :width="item.width" :fixed="item.fixed" :align="item.align">
          <template slot-scope="scope">
            <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
            <span v-else v-html='scope.row[item.prop]'></span>
            <!-- <span v-html='scope.row[item.prop]' v-if="item.html==1"></span>
            <template v-else>
              <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
              <span v-else v-html='scope.row[item.prop]'></span>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <table class="excellent-table">
        <tr>
          <th style='width:300px;'>优秀标准</th>
          <th v-for="(item,index) in shenheList" :key="index">
            {{ item.name }}
          </th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td v-for="(it,i) in shenheList" :key="i">
            <span v-if="i!=uuid">{{getBeizhu(item.detail,it.uuid)}}</span>
            <el-input type='textarea' v-model='excellentlist[index].detail[i].beizhu' v-else></el-input>
          </td>
        </tr>
        <tr>
          <td>评选结果</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <el-select size="mini" v-model="item.excellent" v-if="assessinfo.crntleader==item.uuid">
              <el-option label='不评' :value='0'></el-option>
              <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title' :value="item.excellent_id"></el-option>
            </el-select>
            <span v-else>{{formatExcellent(item.excellent,1)}}</span>
          </td>
        </tr>
      </table>
      <div>
        <el-button @click="submdfy(1)" v-if='canRefuse==1' size='mini' type='info'>暂存</el-button>
        <el-button @click="submdfy(2)" v-if='canRefuse==1' size='mini' type="success">提交</el-button>
        <el-button @click="refuse" v-if='canRefuse==1' size='mini' type="danger">驳回</el-button>
        <el-button @click="assDiv=false" size='mini'>返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      info: [],
      assessinfo: {},
      assDiv: false,
      hasscore: 1,
      crntscope: '',
      page: 1,
      total: 0,
      crntDep: '',
      trList: [],
      canRefuse: 0,
      shenheList: {},
      excellentlist: [],
      uuid: sessionStorage.getItem('employeeuuid')
    };
  },
  computed: {
    score() {
      // if(this.hasscore==0) return [];
      let temp = [];
      for (let i in this.info) {
        if (this.info[i][this.uuid + 'did'] != 0)
          temp.push({
            id: this.info[i][this.uuid + 'did'],
            tiid: parseInt(this.info[i].id),
            proportion: this.info[i].proportion,
            score: this.info[i][this.uuid + 'score'] ? parseFloat(this.info[i][this.uuid + 'score']) : 0,
            beizhu: this.info[i][this.uuid + 'beizhu'] ? this.info[i][[this.uuid + 'beizhu']] : '',
          })
      }
      return temp;
    },
    alist() {
      if (this.hasscore == 0) return this.info;
      let temp = {
        id: 0,
        title: '合计',
        readonly: 1,
      }
      let shenhe = [];
      for (let item in this.shenheList) {
        shenhe.push(this.shenheList[item].uuid)
      }
      temp[this.uuid + 'score'] = 0;
      for (let item in this.info) {
        temp[this.uuid + 'score'] += isNaN(parseFloat(this.info[item][this.uuid + 'score'])) ? 0 : parseFloat(this.info[item][this.uuid + 'score']);
      }
      for (let item in this.assessinfo.detail) {
        //console.log(this.assessinfo.detail[item].uuid,this.uuid,temp[this.uuid + 'score'],this.assessinfo.detail[item].score)
        if (this.assessinfo.detail[item].uuid == this.uuid) {
          console.log(this.assessinfo.detail[item].score, temp[this.uuid + 'score'])
          this.assessinfo.detail[item].score = temp[this.uuid + 'score']
          console.log(this.assessinfo.detail[item].score, temp[this.uuid + 'score'])
          break;
        }
      } console.log(this.assessinfo.detail)
      return this.info.concat(temp);
    },
  },
  methods: {
    getBeizhu(item, uuid) {
      for (let i in item) {
        if (i == uuid) {
          return item[i].beizhu
        }
      }
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/leaderass/getDepList",
        method: "post",
        data: {},
      }).then((res) => {
        this.list = res.data.list;
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
      sessionStorage.setItem('leader_assess_page', p);
    },
    formatExcellent(e) {
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
      return '不评';
    },
    ass(scope) {
      this.crntscope = scope;
      let id = scope.row.id;
      this.$axios({
        url: this.HOST + "/kaohe/leaderass/getAssByDep",
        method: "post",
        data: {
          id: id
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.info = res.data.list;
          this.assessinfo = res.data.assinfo;
          for (let item in this.assessinfo.detail) {
            this.assessinfo.detail[item].excellent = parseInt(this.assessinfo.detail[item].excellent)
          }
          this.hasscore = res.data.hasscore;
          this.crntDep = scope.row.department;
          this.assDiv = true;
          this.excellentlist = res.data.excellentlist;
          this.trList = res.data.trList;
          this.canRefuse = res.data.canRefuse;
          this.shenheList = res.data.shenheList
          for (let item in this.assessinfo.detail) {
            if (this.assessinfo.detail[item].uuid == this.uuid) {
              return
            }
          }
          this.assessinfo.detail.push({
            uuid: this.uuid,
            score: 0,
            excellent: 0
          })
        }
      });
    },
    refuse() {
      this.$confirm(
        '确定要驳回考核吗？',
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/leaderass/refuseDep",
          method: "post",
          data: {
            id: this.assessinfo.id,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.assDiv = false;
            this.getlist();
            this.$message({
              type: "info",
              message: "操作成功",
            });
          }
        });
      });
    },
    submdfy(status) {
      this.$axios({
        url: this.HOST + "/kaohe/leaderass/saveDepAss",
        method: "post",
        data: {
          info: this.assessinfo,
          score: this.score,
          status: status,
          excellent: this.excellentlist,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          this.assDiv = false;
          this.getlist();
        }
      });
    },
  },
  created: function () {
    this.getlist();
  },
};
</script>
<style scoped>
.itemgroup {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px 20px 0 0;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
}
.itemgroup * {
  box-sizing: border-box;
}
.item-title {
  line-height: 28px;
}
</style>